import React from 'react';
import Navbar from './Navbar';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-black text-white flex flex-col items-center justify-start">
        {/* Banner Section */}
        <div className="w-full max-w-6xl mt-6 px-4">
          <img
            src="/images/ngr-banner.png"
            alt="NGR Predictions Banner"
            className="w-full rounded-2xl shadow-lg"
          />
          <div className="text-center mt-4 text-green-400 text-2xl font-semibold">
            Predict. Win. Grow Your Future.
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-10 text-center px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Join NGR Predictions Today
          </h2>
          <p className="text-gray-300 max-w-xl mx-auto text-lg mb-6">
            Access accurate football predictions powered by data. Trusted by professionals and fans worldwide.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/register"
              className="bg-green-500 hover:bg-green-600 text-white py-3 px-6 rounded-full text-lg shadow-md transition"
            >
              Get Started
            </a>
            <a
              href="/login"
              className="border border-white text-white py-3 px-6 rounded-full text-lg hover:bg-white hover:text-black transition"
            >
              Login
            </a>
          </div>
        </div>

        {/* Coming Soon Message */}
        <div className="mt-20 text-center text-sm text-gray-500">
          © 2025 NGR Prediction — Accuracy You Can Count On
        </div>
      </div>
    </>
  );
};

export default HomePage;
